import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Clickthrottle from '@/utils/instructions';
Vue.directive('clickthrottle', Clickthrottle);
const _ = require('lodash')
Vue.config.productionTip = false;
Vue.prototype.$lodash = _
Vue.use(Vuetify, {
  theme: {
    primary: '#1ABC9C', //'#2196F3',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  iconfont: 'md'
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
